import React from "react";
import { ComboboxItem, Select, Text, TextInput, Tooltip } from "@mantine/core";
import RenderTable from "./RenderTable";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { tblInventoryTransaction } from "../../../../model/TblOutWard";
import classesButton from "../../../../../src/Styles/StyleButton.module.css";

const RequestVendorInWard = ({
  dataSearchSourceCodeOption,
  dataPosition,
  dataInWard,
  sourceCode,
  setSourceCode,
  handleKeyDownSourceCode,
  dataOrderDetail,
  handleChangeValueInput,
  isSave,
  setSearchSourceCode,
  isEdit,
  isLocked,
  haveSourceCode,
  action,
  dataSerialStatus,
  setSerialStatusSelectAll,
  dataSerialOnHand,
  dataBranch,
  dataInventoryTransactionType,
}: RequestVendorInWardProps) => {
  const isDisabled =
    dataInWard.status === "LOCK" ||
    sourceCode ||
    isSave ||
    ["DETAIL", "EDIT"].includes(action);
  const headers = [
    { label: "", style: { width: "22%" } },
    { label: "Bên xuất", style: { width: "38%" } },
    { label: "Bên nhận", style: { width: "38%" } },
  ];

  const getDeliveryText = (delivery: string) => {
    switch (delivery) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "NOI_BO":
      case "HA_COM":
        return "Nội bộ";
      default:
        return delivery;
    }
  };

  const rows = [
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian tạo
          </Text>
        ),
      },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOrderDetail?.createDate ?? "")}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian hoàn thành
          </Text>
        ),
      },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOrderDetail?.finishDate)}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã nhà cung cấp
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusCode}
          </Text>
        ),
      },
      {
        content: null,
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu nhập kho
          </Text>
        ),
      },
      {
        content:
          !isEdit && !haveSourceCode ? (
            <Tooltip
              label={
                dataInWard?.sourceCode
                  ? dataInWard?.sourceCode
                  : "Vui lòng chọn phiếu"
              }
            >
              <Select
                w={"160px"}
                placeholder="Mã phiếu yêu cầu nhập kho"
                data={dataSearchSourceCodeOption}
                size="sm"
                disabled={
                  !dataInWard.sourceType ||
                  dataInWard.status === "LOCK" ||
                  sourceCode ||
                  isSave
                }
                searchable
                clearable
                onSearchChange={(e) => {
                  if (setSearchSourceCode) {
                    setSearchSourceCode(e);
                  }
                }}
                onKeyDown={handleKeyDownSourceCode}
                value={sourceCode || dataInWard.sourceCode}
                onChange={(value) => {
                  if (handleChangeValueInput) {
                    handleChangeValueInput(value || "", "sourceCode");
                  }
                  if (setSourceCode) {
                    setSourceCode(value);
                  }
                }}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            </Tooltip>
          ) : (
            <Text
              w={"150px"}
              size="sm"
              style={{ whiteSpace: "normal" }}
              truncate
            >
              {dataOrderDetail.sourceCode}{" "}
            </Text>
          ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.transactionCode}
          </Text>
        ),
      },
    ],
    // [
    //   {
    //     content: (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         Lý do
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: !isDisabled ? (
    //       <Select
    //         searchable
    //         clearable
    //         w={160}
    //         placeholder="Chọn lý do"
    //         disabled={
    //           dataInWard.status === "LOCK" ||
    //           sourceCode ||
    //           isSave ||
    //           ["DETAIL", "EDIT"].includes(action)
    //         }
    //         data={dataInventoryTransactionType}
    //         value={dataInWard.sourceType?.toString() || ""}
    //         onChange={(value) => {
    //           handleChangeValueInput(value || "", "sourceType");
    //         }}
    //       />
    //     ) : (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         {
    //           dataInventoryTransactionType?.find(
    //             (t) => t.value === dataInWard.sourceType?.toString()
    //           )?.label
    //         }
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: null,
    //   },
    // ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Tên nhà cung cấp
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.cusName}
          </Text>
        ),
      },
      {
        content: null,
      },
    ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chi nhánh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataBranch &&
              dataBranch?.find(
                (i: any) =>
                  String(i?.orgId) === String(dataOrderDetail?.fromBranchId),
              )?.orgCode}{" "}
            - {dataOrderDetail.fromBranchName}
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataBranch &&
              dataBranch?.find(
                (i: any) =>
                  String(i?.orgId) === String(dataOrderDetail?.toBranchId),
              )?.orgCode}{" "}
            - {dataOrderDetail.toBranchName}
          </Text>
        ),
      },
    ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Kho
          </Text>
        ),
      },
      {
        content: (
          <Text w="150px" size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.fromInvCode
              ? `${dataOrderDetail.fromInvCode} - ${
                  dataOrderDetail.fromInvName || ""
                }`
              : dataOrderDetail.fromInvName || ""}
          </Text>
        ),
      },
      {
        content: (
          <Text w="150px" size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.toInvCode
              ? `${dataOrderDetail.toInvCode} - ${
                  dataOrderDetail.toInvName || ""
                }`
              : dataOrderDetail.toInvName || ""}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text fw={700} size={"sm"}>
            Vị trí
          </Text>
        ),
      },
      {
        content: <Text size={"sm"}>{dataOrderDetail.fromPositionName}</Text>,
      },
      {
        content: (
          <Tooltip
            label={
              dataInWard?.toPositionId
                ? dataPosition?.find(
                    (p) =>
                      String(p.value) === dataInWard?.toPositionId?.toString(),
                  )?.label
                : "Vui lòng chọn vị trí"
            }
          >
            <Select
              w={"160px"}
              placeholder="Vị trí"
              data={dataPosition}
              size="sm"
              disabled={
                !dataInWard.sourceType ||
                dataInWard.status === "LOCK" ||
                isSave ||
                isLocked
              }
              searchable
              clearable
              value={dataInWard.toPositionId?.toString()}
              onChange={(value) => {
                handleChangeValueInput(value, "toPositionId");
              }}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Tooltip>
        ),
      },
    ],
    !isLocked
      ? [
          {
            content: (
              <Text fw={700} size={"sm"}>
                Tình trạng
              </Text>
            ),
          },
          {
            content: <></>,
          },
          {
            content: (
              <Select
                w={"160px"}
                placeholder="Tình trạng"
                data={dataSerialStatus}
                size="sm"
                disabled={
                  !dataInWard.sourceType ||
                  dataInWard.status === "LOCK" ||
                  isSave ||
                  isLocked ||
                  !dataSerialOnHand ||
                  dataSerialOnHand?.length === 0
                }
                searchable
                clearable
                onChange={(e) => setSerialStatusSelectAll(e ? e : "")}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            ),
          },
        ]
      : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa điểm làm việc
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.fromBranchAddress}
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.toBranchAddress}
          </Text>
        ),
      },
    ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Người giao dịch
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.transactionPerson || ""}
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createName
              ? dataOrderDetail?.createName +
                " - " +
                dataOrderDetail?.createCode
              : ""}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chức danh
          </Text>
        ),
      },
      { content: null },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createRoleName || ""}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Giao hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {getDeliveryText(dataOrderDetail?.delivery || "")}
          </Text>
        ),
      },
      { content: null },
    ],
    isLocked || isEdit
      ? [
          {
            content: (
              <Text
                fw={700}
                w={"100px"}
                size="sm"
                style={{ whiteSpace: "normal" }}
                truncate
              >
                Diễn giải chứng từ gốc
              </Text>
            ),
          },
          {
            content: (
              <Text size="sm" w={"500px"}>
                {dataInWard?.sourceDescription}
              </Text>
            ),
            colSpan: 2,
          },
        ]
      : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Ghi chú
          </Text>
        ),
      },
      {
        content: (
          <TextInput
            error={
              dataInWard?.description && dataInWard.description.length > 300
                ? "Ghi chú không được vượt quá 300 kí tự!"
                : null
            }
            className={classesButton.text_input}
            value={dataInWard?.description ?? ""}
            onChange={(e) => {
              handleChangeValueInput(e.target.value, "description");
            }}
            disabled={isLocked}
            placeholder={isLocked ? "" : "Vui lòng nhập"}
          />
        ),
        colSpan: 2,
      },
    ],
  ];

  return (
    <RenderTable
      headers={headers}
      rows={rows.filter((item) => item.length !== 0)}
    />
  );
};

type RequestVendorInWardProps = {
  dataSearchSourceCodeOption?: any[];
  dataPosition?: ComboboxItem[];
  dataInWard: tblInventoryTransaction;
  dataOrderDetail: any;
  userInfo: any;
  handleChangeValueInput: (value: string | boolean | null, key: string) => void;
  setSourceCode?: (value: any) => void;
  handleKeyDownSourceCode?: (e: any) => void;
  sourceCode?: any;
  isSave?: boolean;
  setSearchSourceCode?: (newValue: React.SetStateAction<string>) => void;
  isEdit?: boolean;
  isLocked?: boolean;
  haveSourceCode?: boolean;
  action: string;
  dataSerialStatus?: any[];
  setSerialStatusSelectAll?: any;
  dataSerialOnHand?: any[];
  dataBranch?: any;
  dataInventoryTransactionType?: ComboboxItem[];
};

export default RequestVendorInWard;
